<br>
<br>

<!--div class="panel-heading">
    <a class="centrado"><img src="./assets/img/cnsf.png"></a>
    <br><br>
    <h4 class="panel-title center">
       </h4>
</div-->
<label class="panel-title"> Constancias de registro</label>
<hr class="red">
<button type="button" name="salir" class="btn btn-primary float-end" (click)="salir()">Salir</button>
<br>
<br>
<div *ngIf="cedulas?.length == 0; else vistaTabla" class="alert alert-info">
    No Se Encontraron Constancias No Descargadas En La Base De Datos
</div>


<ng-template #vistaTabla>
    <div class="card-body">

        <table class="table table-bordered table-striped">
            <thead>
                <tr>
                    <th>No. De Cédula</th>
                    <th>Fecha De Emisión</th>
                    <th>Apartado De Descarga</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let cedula of cedulas">
                    <td>{{cedula.numeroCedula}}</td>
                    <td>{{cedula.fechaimpresion}}</td>

                    <td>
                        <button type="button" name="descargar" class="btn btn-primary" (click)="actualizaConstancia(cedula)">Obten Cédula</button>
                    </td>

                </tr>

            </tbody>
        </table>

    </div>
    <br>
</ng-template>
<div class="row">
    <div *ngIf="muestraDescarga" class="col-md-2">
        <!--<a [href]='pdfSrc' download target="_blank" class="btn btn-primary" rel="noopener noreferrer" 
        (click)="refrescaVentana()">Descargar Cédula</a> -->
        <a class="btn btn-primary" rel="noopener noreferrer" (click)="mostrarPDF()">Descargar Cédula</a>
    </div>
    <div *ngIf="muestraEncuesta" class="col-md-3">
        <a tabindex="5" class="btn btn-link" href="https://forms.office.com/r/xj39JeH06z" target="_blank">Encuesta de satisfacción
          <span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>
        </a>
    </div>
</div>
<br>
